// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as ApolloConfig from "../../core/ApolloConfig.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as InputTextAreaField from "../../resources/selection-and-input/InputTextAreaField.res.js";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation updateVariant_tastingNote($id: ID!, $input: InputUpdateVariant!)  {\nupdateVariant(id: $id, input: $input)  {\n__typename  \nid  \ntastingNote  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.tastingNote;
  return {
    updateVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      tastingNote: !(value$2 == null) ? Scalar.Text.parse(value$2) : undefined
    }
  };
}

function serialize(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.tastingNote;
  let tastingNote = value$2 !== undefined ? Scalar.Text.serialize(value$2) : null;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let updateVariant = {
    __typename: value$4,
    id: value$3,
    tastingNote: tastingNote
  };
  return {
    updateVariant: updateVariant
  };
}

function serializeInputObjectInputUpdateVariantMetaData(inp) {
  let a = inp.shopifyVariantId;
  return {
    shopifyVariantId: a !== undefined ? a : undefined
  };
}

function serializeInputObjectInputUpdateVariant(inp) {
  let a = inp.stockKeepingUnit;
  let a$1 = inp.name;
  let a$2 = inp.purchasedPrice;
  let a$3 = inp.year;
  let a$4 = inp.capacityValue;
  let a$5 = inp.capacityUnit;
  let a$6 = inp.capacityPrecision;
  let a$7 = inp.alcoholVolume;
  let a$8 = inp.ean13;
  let a$9 = inp.internalNote;
  let a$10 = inp.metadata;
  let a$11 = inp.tastingNote;
  let a$12 = inp.packaging;
  let a$13 = inp.internalCode;
  let a$14 = inp.priceLookUpCode;
  let a$15 = inp.supplierId;
  let a$16 = inp.minStockThreshold;
  let a$17 = inp.maxStockThreshold;
  let a$18 = inp.stockOrderTriggerThreshold;
  return {
    stockKeepingUnit: a !== undefined ? a : undefined,
    name: a$1 !== undefined ? a$1 : undefined,
    purchasedPrice: a$2 !== undefined ? a$2 : undefined,
    year: a$3 !== undefined ? a$3 : undefined,
    capacityValue: a$4 !== undefined ? a$4 : undefined,
    capacityUnit: a$5 !== undefined ? a$5 : undefined,
    capacityPrecision: a$6 !== undefined ? a$6 : undefined,
    alcoholVolume: a$7 !== undefined ? a$7 : undefined,
    ean13: a$8 !== undefined ? a$8 : undefined,
    internalNote: a$9 !== undefined ? a$9 : undefined,
    metadata: a$10 !== undefined ? serializeInputObjectInputUpdateVariantMetaData(a$10) : undefined,
    tastingNote: a$11 !== undefined ? a$11 : undefined,
    packaging: a$12 !== undefined ? a$12 : undefined,
    internalCode: a$13 !== undefined ? a$13 : undefined,
    priceLookUpCode: a$14 !== undefined ? a$14 : undefined,
    supplierId: a$15 !== undefined ? a$15 : undefined,
    minStockThreshold: a$16 !== undefined ? a$16 : undefined,
    maxStockThreshold: a$17 !== undefined ? a$17 : undefined,
    stockOrderTriggerThreshold: a$18 !== undefined ? a$18 : undefined
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateVariant(inp.input)
  };
}

function makeVariables(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputUpdateVariant(stockKeepingUnit, name, purchasedPrice, year, capacityValue, capacityUnit, capacityPrecision, alcoholVolume, ean13, internalNote, metadata, tastingNote, packaging, internalCode, priceLookUpCode, supplierId, minStockThreshold, maxStockThreshold, stockOrderTriggerThreshold, param) {
  return {
    stockKeepingUnit: stockKeepingUnit,
    name: name,
    purchasedPrice: purchasedPrice,
    year: year,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    internalNote: internalNote,
    metadata: metadata,
    tastingNote: tastingNote,
    packaging: packaging,
    internalCode: internalCode,
    priceLookUpCode: priceLookUpCode,
    supplierId: supplierId,
    minStockThreshold: minStockThreshold,
    maxStockThreshold: maxStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold
  };
}

function makeInputObjectInputUpdateVariantMetaData(shopifyVariantId, param) {
  return {
    shopifyVariantId: shopifyVariantId
  };
}

let UpdateVariantTastingNoteMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let UpdateVariantTastingNoteMutation_useWithVariables = include.useWithVariables;

let UpdateVariantTastingNoteMutation = {
  UpdateVariantTastingNoteMutation_inner: UpdateVariantTastingNoteMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData,
  use: use,
  useWithVariables: UpdateVariantTastingNoteMutation_useWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation updateVariant_internalNote($id: ID!, $input: InputUpdateVariant!)  {\nupdateVariant(id: $id, input: $input)  {\n__typename  \nid  \ninternalNote  \n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.internalNote;
  return {
    updateVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      internalNote: !(value$2 == null) ? Scalar.Text.parse(value$2) : undefined
    }
  };
}

function serialize$1(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.internalNote;
  let internalNote = value$2 !== undefined ? Scalar.Text.serialize(value$2) : null;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let updateVariant = {
    __typename: value$4,
    id: value$3,
    internalNote: internalNote
  };
  return {
    updateVariant: updateVariant
  };
}

function serializeInputObjectInputUpdateVariantMetaData$1(inp) {
  let a = inp.shopifyVariantId;
  return {
    shopifyVariantId: a !== undefined ? a : undefined
  };
}

function serializeInputObjectInputUpdateVariant$1(inp) {
  let a = inp.stockKeepingUnit;
  let a$1 = inp.name;
  let a$2 = inp.purchasedPrice;
  let a$3 = inp.year;
  let a$4 = inp.capacityValue;
  let a$5 = inp.capacityUnit;
  let a$6 = inp.capacityPrecision;
  let a$7 = inp.alcoholVolume;
  let a$8 = inp.ean13;
  let a$9 = inp.internalNote;
  let a$10 = inp.metadata;
  let a$11 = inp.tastingNote;
  let a$12 = inp.packaging;
  let a$13 = inp.internalCode;
  let a$14 = inp.priceLookUpCode;
  let a$15 = inp.supplierId;
  let a$16 = inp.minStockThreshold;
  let a$17 = inp.maxStockThreshold;
  let a$18 = inp.stockOrderTriggerThreshold;
  return {
    stockKeepingUnit: a !== undefined ? a : undefined,
    name: a$1 !== undefined ? a$1 : undefined,
    purchasedPrice: a$2 !== undefined ? a$2 : undefined,
    year: a$3 !== undefined ? a$3 : undefined,
    capacityValue: a$4 !== undefined ? a$4 : undefined,
    capacityUnit: a$5 !== undefined ? a$5 : undefined,
    capacityPrecision: a$6 !== undefined ? a$6 : undefined,
    alcoholVolume: a$7 !== undefined ? a$7 : undefined,
    ean13: a$8 !== undefined ? a$8 : undefined,
    internalNote: a$9 !== undefined ? a$9 : undefined,
    metadata: a$10 !== undefined ? serializeInputObjectInputUpdateVariantMetaData$1(a$10) : undefined,
    tastingNote: a$11 !== undefined ? a$11 : undefined,
    packaging: a$12 !== undefined ? a$12 : undefined,
    internalCode: a$13 !== undefined ? a$13 : undefined,
    priceLookUpCode: a$14 !== undefined ? a$14 : undefined,
    supplierId: a$15 !== undefined ? a$15 : undefined,
    minStockThreshold: a$16 !== undefined ? a$16 : undefined,
    maxStockThreshold: a$17 !== undefined ? a$17 : undefined,
    stockOrderTriggerThreshold: a$18 !== undefined ? a$18 : undefined
  };
}

function serializeVariables$1(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateVariant$1(inp.input)
  };
}

function makeVariables$1(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputUpdateVariant$1(stockKeepingUnit, name, purchasedPrice, year, capacityValue, capacityUnit, capacityPrecision, alcoholVolume, ean13, internalNote, metadata, tastingNote, packaging, internalCode, priceLookUpCode, supplierId, minStockThreshold, maxStockThreshold, stockOrderTriggerThreshold, param) {
  return {
    stockKeepingUnit: stockKeepingUnit,
    name: name,
    purchasedPrice: purchasedPrice,
    year: year,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    internalNote: internalNote,
    metadata: metadata,
    tastingNote: tastingNote,
    packaging: packaging,
    internalCode: internalCode,
    priceLookUpCode: priceLookUpCode,
    supplierId: supplierId,
    minStockThreshold: minStockThreshold,
    maxStockThreshold: maxStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold
  };
}

function makeInputObjectInputUpdateVariantMetaData$1(shopifyVariantId, param) {
  return {
    shopifyVariantId: shopifyVariantId
  };
}

let UpdateVariantInternalNoteMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant$1,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData$1,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant$1,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData$1
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let UpdateVariantInternalNoteMutation_useWithVariables = include$1.useWithVariables;

let UpdateVariantInternalNoteMutation = {
  UpdateVariantInternalNoteMutation_inner: UpdateVariantInternalNoteMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant$1,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData$1,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant$1,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData$1,
  use: use$1,
  useWithVariables: UpdateVariantInternalNoteMutation_useWithVariables
};

function CatalogVariantNotesCard(props) {
  let activeShop = Auth.useActiveShop();
  let match = Stdlib_Option.mapOr(props.shopsNotes.find(productNotes => Primitive_object.equal(productNotes.shopId, Stdlib_Option.map(activeShop, param => param.id))), [
    "",
    "",
    ""
  ], notes => [
    notes.variantId,
    notes.tastingNote,
    notes.internalNote
  ]);
  let initialInternalNote = match[2];
  let initialTastingNote = match[1];
  let variantId = match[0];
  let match$1 = React.useState(() => initialTastingNote);
  let setTastingNote = match$1[1];
  let tastingNote = match$1[0];
  let debouncedTastingNote = ReactUpdateDebounced.use(tastingNote, ApolloConfig.mutationDebounceInterval);
  let match$2 = React.useState(() => initialInternalNote);
  let setInternalNote = match$2[1];
  let internalNote = match$2[0];
  let debouncedInternalNote = ReactUpdateDebounced.use(internalNote, ApolloConfig.mutationDebounceInterval);
  let match$3 = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutateTastingNote = match$3[0];
  let match$4 = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutateInternalNote = match$4[0];
  let match$5 = React.useState(() => "NoError");
  let setError = match$5[1];
  let error = match$5[0];
  let onMutateTastingNoteRequested = React.useCallback(tastingNote => {
    let input = makeInputObjectInputUpdateVariant(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Scalar.Text.serialize(tastingNote), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    Future.get(FuturePromise.fromPromise(mutateTastingNote(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: Stdlib_Option.getOr(variantId, ""),
      input: input
    })), response => {
      if (response.TAG === "Ok") {
        let match = response._0;
        if (match.TAG === "Ok" && match._0.error === undefined) {
          return setError(param => "NoError");
        }
      }
      setTastingNote(param => initialTastingNote);
      setError(param => ({
        TAG: "TastingNoteUpdatingError",
        _0: I18n.t("Couldn't update the tasting note.")
      }));
    });
  }, [variantId]);
  let onMutateInternalNoteRequested = React.useCallback(internalNote => {
    let input = makeInputObjectInputUpdateVariant$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Scalar.Text.serialize(internalNote), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    Future.get(FuturePromise.fromPromise(mutateInternalNote(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: Stdlib_Option.getOr(variantId, ""),
      input: input
    })), response => {
      if (response.TAG === "Ok") {
        let match = response._0;
        if (match.TAG === "Ok" && match._0.error === undefined) {
          return setError(param => "NoError");
        }
      }
      setInternalNote(param => initialInternalNote);
      setError(param => ({
        TAG: "InternalNoteUpdatingError",
        _0: I18n.t("Couldn't update the internal note.")
      }));
    });
  }, [variantId]);
  ReactUpdateEffect.use1(() => {
    onMutateTastingNoteRequested(debouncedTastingNote);
  }, [debouncedTastingNote]);
  ReactUpdateEffect.use1(() => {
    onMutateInternalNoteRequested(debouncedInternalNote);
  }, [debouncedInternalNote]);
  let match$6 = Auth.useScope();
  let tmp;
  let exit = 0;
  if (match$6.TAG === "Organisation" && match$6.activeShop === undefined) {
    tmp = JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Banner.make, {
        textStatus: {
          TAG: "Info",
          _0: I18n.t("Filter the product page on a single shop to visualize and update its tasting note or internal memo.")
        },
        compact: false
      }),
      spaceTop: "medium"
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    let tmp$1;
    tmp$1 = typeof error !== "object" || error.TAG !== "TastingNoteUpdatingError" ? undefined : error._0;
    let tmp$2;
    tmp$2 = typeof error !== "object" || error.TAG === "TastingNoteUpdatingError" ? undefined : error._0;
    tmp = JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(InputTextAreaField.make, {
          label: I18n.t("Tasting note"),
          errorMessage: tmp$1,
          value: tastingNote,
          onChange: value => setTastingNote(param => value)
        }),
        JsxRuntime.jsx(InputTextAreaField.make, {
          label: I18n.t("Internal memo"),
          errorMessage: tmp$2,
          value: internalNote,
          onChange: value => setInternalNote(param => value)
        })
      ],
      space: "xlarge"
    });
  }
  return JsxRuntime.jsx(Card.make, {
    children: tmp,
    title: "Notes"
  });
}

let make = React.memo(CatalogVariantNotesCard);

export {
  UpdateVariantTastingNoteMutation,
  UpdateVariantInternalNoteMutation,
  make,
}
/* query Not a pure module */
